export interface Review {
  id: number;
  userID: number;
  userName: string;
  productID: number;
  productName: string;
  comment: string;
  rating: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const reviewFromResponse = (responseData: any): Review => ({
  id: responseData.id,
  userID: responseData.user_id,
  userName: responseData.user_name,
  productID: responseData.product_id,
  productName: responseData.product_name,
  comment: responseData.comment,
  rating: responseData.rating,
  isActive: responseData.is_active,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const reviewToUpsertRequest = (review: Review) => ({
  comment: review.comment,
  rating: review.rating,
  is_active: review.isActive,
});
